import { Component } from '@angular/core';

@Component({
  selector: 'app-latest-releases',
  templateUrl: './latest-releases.component.html',
  styleUrl: './latest-releases.component.scss'
})
export class LatestReleasesComponent {

}
